{
  "id": 9,
  "location": "cafe",
  "difficulty": "easy",
  "moves": 14,
  "kinds": 5,
  "goals": [
    { "type": "collect", "kind": "macaron", "count": 38 }
  ],
  "stars": [4610, 6180],
  "board": [
    "# # . . . . # #",
    "# . . . . . . #",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    "# . . . . . . #",
    "# # . . . . # #"
  ],
  "calibration": { "runs": 1000, "winRate": 0.911, "movesLeft": 4, "closeLosses": 0.036, "target": 0.92 }
}
